import { gql } from '@apollo/client';
import { OrderInfo } from '../fragments';

export default gql`
  query order($id: ID) {
    order(id: $id) {
      ...OrderInfo
    }
  }
  ${OrderInfo}
`;
